import React, { useState } from 'react';
import BusinessListingBot from '../components/BusinessListingBot';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLinkedin,
    FaYoutube,
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
    FaClock,
    FaArrowUp,
    FaHeart,
    FaShieldAlt,
    FaUsers,
    FaGlobe,
    FaStar,
    FaRocket
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(false);

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        if (email) {
            setIsSubscribed(true);
            setEmail('');
            setTimeout(() => setIsSubscribed(false), 3000);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            {/* Main Footer Content */}
            <div className="footer-main">
                <Container>
                    <Row className="g-4">
                        {/* Company Info */}
                        <Col lg={4} md={6}>
                            <motion.div 
                                className="footer-section"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                            >
                                <div className="footer-logo">
                                    <motion.div 
                                        className="logo-icon"
                                        whileHover={{ scale: 1.1, rotate: 5 }}
                                        transition={{ type: "spring", stiffness: 300 }}
                                    >
                                        <FaGlobe />
                                    </motion.div>
                                    <h3>Business Directory</h3>
                                </div>
                                <p className="footer-description">
                                    Discover the best local businesses in your area. From restaurants to services, 
                                    we connect you with trusted professionals who deliver exceptional experiences.
                                </p>
                                
                                {/* Features */}
                                <div className="footer-features">
                                    <div className="feature-item">
                                        <FaShieldAlt className="feature-icon" />
                                        <span>Trusted & Verified</span>
                                    </div>
                                    <div className="feature-item">
                                        <FaUsers className="feature-icon" />
                                        <span>Community Driven</span>
                                    </div>
                                    <div className="feature-item">
                                        <FaRocket className="feature-icon" />
                                        <span>Fast & Reliable</span>
                                    </div>
                                </div>

                                {/* Social Media */}
                                <div className="social-links">
                                    <motion.a 
                                        href="#" 
                                        className="social-link"
                                        whileHover={{ scale: 1.2, y: -3 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaFacebook />
                                    </motion.a>
                                    <motion.a 
                                        href="#" 
                                        className="social-link"
                                        whileHover={{ scale: 1.2, y: -3 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaTwitter />
                                    </motion.a>
                                    <motion.a 
                                        href="#" 
                                        className="social-link"
                                        whileHover={{ scale: 1.2, y: -3 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaInstagram />
                                    </motion.a>
                                    <motion.a 
                                        href="#" 
                                        className="social-link"
                                        whileHover={{ scale: 1.2, y: -3 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaLinkedin />
                                    </motion.a>
                                    <motion.a 
                                        href="#" 
                                        className="social-link"
                                        whileHover={{ scale: 1.2, y: -3 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaYoutube />
                                    </motion.a>
                                </div>
                            </motion.div>
                        </Col>

                        {/* Quick Links */}
                        <Col lg={2} md={6}>
                            <motion.div 
                                className="footer-section"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                <h4 className="footer-title">Quick Links</h4>
                                <ul className="footer-links">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/">Browse Businesses</Link></li>
                                    <li><Link to="/add-business">Add Business</Link></li>
                                    <li><Link to="/download-visiting-cards">Generate Visiting Card</Link></li>
                                    <li><Link to="/tutors-scraper">Tutors Scraper (CSV)</Link></li>
                                    <li><Link to="/contact">Contact</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                </ul>
                            </motion.div>
                        </Col>

                        {/* Services */}
                        <Col lg={2} md={6}>
                            <motion.div 
                                className="footer-section"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                <h4 className="footer-title">Services</h4>
                                <ul className="footer-links">
                                    <li><Link to="/Restaurants">Restaurants</Link></li>
                                    <li><Link to="/Hotels">Hotels</Link></li>
                                    <li><Link to="/services/BeautySpa">Beauty Spa</Link></li>
                                    <li><Link to="/services/Dentists">Dentists</Link></li>
                                    <li><Link to="/services/WeddingPlanning">Wedding Planning</Link></li>
                                    <li><Link to="/services/RentHire">Rent & Hire</Link></li>
                                    <li><Link to="/services-grid">All Services Grid</Link></li>
                                </ul>
                            </motion.div>
                        </Col>

                        {/* Contact Info */}
                        <Col lg={4} md={6}>
                            <motion.div 
                                className="footer-section"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                            >
                                <h4 className="footer-title">Contact Info</h4>
                                <div className="contact-info">
                                    <div className="contact-item">
                                        <FaPhone className="contact-icon" />
                                        <div>
                                            <h6>Phone</h6>
                                            <p>+1 (555) 123-4567</p>
                                        </div>
                                    </div>
                                    <div className="contact-item">
                                        <FaEnvelope className="contact-icon" />
                                        <div>
                                            <h6>Email</h6>
                                            <p>info@businessdirectory.com</p>
                                        </div>
                                    </div>
                                    <div className="contact-item">
                                        <FaMapMarkerAlt className="contact-icon" />
                                        <div>
                                            <h6>Address</h6>
                                            <p>123 Business Ave, Suite 100<br />City, State 12345</p>
                                        </div>
                                    </div>
                                    <div className="contact-item">
                                        <FaClock className="contact-icon" />
                                        <div>
                                            <h6>Business Hours</h6>
                                            <p>Mon - Fri: 9:00 AM - 6:00 PM<br />Sat: 10:00 AM - 4:00 PM</p>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>

                    {/* Newsletter Section */}
                    <motion.div 
                        className="newsletter-section"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                    >
                        <Row className="align-items-center">
                            <Col lg={6}>
                                <div className="newsletter-content">
                                    <h4>Stay Updated</h4>
                                    <p>Subscribe to our newsletter for the latest business updates, tips, and exclusive offers.</p>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <Form onSubmit={handleNewsletterSubmit} className="newsletter-form">
                                    <InputGroup>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                        <Button type="submit" variant="primary" className="newsletter-btn">
                                            Subscribe
                                        </Button>
                                    </InputGroup>
                                    {isSubscribed && (
                                        <motion.div 
                                            className="subscription-success"
                                            initial={{ opacity: 0, scale: 0.8 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                        >
                                            <FaStar /> Thank you for subscribing!
                                        </motion.div>
                                    )}
                                </Form>
                            </Col>
                        </Row>
                    </motion.div>
                </Container>
            </div>

            {/* Footer Bottom */}

{/* Business Listing Assistant Bot Section */}
          {/*  <section className="business-bot-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} className="text-center">
                            <BusinessListingBot />
                        </Col>
                    </Row>
                </Container>
            </section> */}

            <div className="footer-bottom">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div className="footer-bottom-left">
                                <p>&copy; {currentYear} Business Directory. All rights reserved.</p>
                                <div className="footer-bottom-links">
                                    <Link to="/privacy">Privacy Policy</Link>
                                    <Link to="/terms">Terms of Service</Link>
                                    <Link to="/cookies">Cookie Policy</Link>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="footer-bottom-right">
                                <div className="footer-stats">
                                    <span><FaUsers /> 10K+ Users</span>
                                    <span><FaGlobe /> 500+ Businesses</span>
                                    <span><FaStar /> 4.8 Rating</span>
                                </div>
                                <motion.button 
                                    className="scroll-to-top"
                                    onClick={scrollToTop}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                >
                                    <FaArrowUp />
                                </motion.button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Made with Love */}
            <div className="made-with-love">
                <p>
                    Made with <FaHeart className="heart-icon" /> by the Business Directory Team
                </p>
            </div>
        </footer>


  










    );
};

export default Footer;
